<template>
  <iColumn align="center">
    <iText text-align="center">
      Start by entering your email address
    </iText>
    <iColumn v-if="$vssMobile" :max-width="400" align="center">
      <iTextInput
        v-model="userAuthEmail"
        placeholder="your@email.com"
        width="fill"
        focus
        @enter="goToPasswordStep"
      />
      <iButton
        :is-loading="isLoading"
        loading-spinner-position="inside"
        :disabled="isLoading || !isValidEmail"
        @click="goToPasswordStep"
      >
        Continue
      </iButton>
    </iColumn>
    <iRow
      v-else
      wrap="nowrap"
      :max-width="400"
      align="center"
    >
      <iTextInput
        v-model="userAuthEmail"
        placeholder="your@email.com"
        width="fill"
        :focus="true"
        @enter="goToPasswordStep"
      />
      <iButton
        :is-loading="isLoading"
        loading-spinner-position="inside"
        :disabled="isLoading || !isValidEmail"
        @click="goToPasswordStep"
      >
        Continue
      </iButton>
    </iRow>
    <iText v-if="verifyUserErrorMessage" variant="error">
      {{ verifyUserErrorMessage }}
    </iText>

    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "@/components/join-publication/PoweredByInspiration";
import { mapActions, mapState, mapWritableState } from "pinia";
import { useUserStore } from "@/stores/user-store";
import { useWindowStore, validateEmail } from "@vcl";

export default {
  name: "JoinPublicationEmail",
  components: { PoweredByInspiration },
  computed: {
    ...mapWritableState(useUserStore, [
      "userAuthEmail",
      "userFlowSteps",
      "verifyUserErrorMessage",
    ]),
    ...mapState(useUserStore, [
      "isLoading",
    ]),
    ...mapState(useWindowStore, [
      "$vssMobile",
    ]),
    isValidEmail() {
      return this.validateEmailAddress(this.userAuthEmail?.trim()).isValid;
    },
  },
  created() {
    useWindowStore().init();
  },
  mounted() {
    this.verifyUserErrorMessage = "";
  },
  beforeUnmount() {
    useWindowStore().remove();
  },
  methods: {
    ...mapActions(useUserStore, [
      "verifyUserExists",
    ]),
    validateEmailAddress(email) {
      if (!email) {
        return {
          isValid: false,
          message: "Please enter your email address",
        };
      }

      if (!validateEmail(email)) {
        return {
          isValid: false,
          message: "Please enter a valid email address",
        };
      }

      return {
        isValid: true,
        message: "",
      };
    },
    goToPasswordStep() {
      const email = this.userAuthEmail?.trim();
      const { isValid, message } = this.validateEmailAddress(email);

      if (!isValid) {
        this.verifyUserErrorMessage = message;
        return;
      }

      this.verifyUserErrorMessage = "";
      this.verifyUserExists(email, 1);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
